var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 21",
    style: {
      enableBackground: "new 0 0 12 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,20.4l-9.2-9.1c-0.4-0.4-0.4-1,0-1.4l9.3-9.1c0.6-0.6,1.5-0.6,2,0c0.6,0.6,0.6,1.5,0,2l-7.9,7.8l7.9,7.8 c0.6,0.6,0.6,1.5,0,2C11,21,10.1,21,9.5,20.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic_back.f46d7ceee6b42438ba6c5da2211493d6.svg";
export { ForwardRef as ReactComponent };